<template>

	<form v-if="field">

		<h3>Field options</h3>

		<a href="#" class="btn-group" data-tab-btn="options-field" data-tab-group="options-bar"><i class="fa fa-plus"></i>
			Field settings</a>
		<div class="group" data-tab-body="options-field" data-tab-group="options-bar">

			<ul class="form">
				<li>

					<table>
						<!-- <tr>
							<th v-for="lang in languages" :key="lang.id">{{lang.language}} <span v-if="lang.region">({{lang.region}})</span><br></th>
						</tr> -->
						<!-- <tr>
							<td>
								<label>Label</label> <input type="text" name="placeholder" value="My fieldname">
							</td>
							<td>
								<label>Label</label> <input type="text" name="placeholder" value="My fieldname">
							</td>
							<td>
								<label>Label</label> <input type="text" name="placeholder" value="My fieldname">
							</td>
						</tr>
						<tr>
							<td>
								<label>Placeholder</label> <input type="text" name="placeholder" value="My fieldname">
							</td>
							<td>
								<label>Placeholder</label> <input type="text" name="placeholder" value="My fieldname">
							</td>
							<td>
								<label>Placeholder</label> <input type="text" name="placeholder" value="My fieldname">
							</td>
						</tr> -->
						<tr>
							<!-- <td v-for="lang in languages" :key="lang.id">
								<label>Description</label> <textarea :name="`settings.description.translations.${lang.locale}.value`"></textarea>
							</td> -->
							<td>
								<label>Description</label> <textarea :name="`property.settings.description.value`" :value="descriptionField"></textarea>
							</td>
						</tr>
					</table>

				</li>
				<li>
					<label>Validation</label>
					<div class="selector">
						<select name="property.settings.validation.value" :value="validationField">
							<option value="0">Select field</option>
							<option value="1">At least 1 character</option>
							<option value="2" selected="selected">At least 2 characters</option>
							<option value="3">At least 8 characters</option>
							<option value="4">Email-address</option>
							<option value="5">Natural number</option>
							<option value="6">Any number</option>
							<option value="7">Currency notation</option>
							<option value="8">Language-code of 2 characters</option>
							<option value="9">Date</option>
							<option value="10">Date and time</option>
							<option value="11">URL (domain, ex: http://www.three-sixty.be</option>
							<option value="12">URI (parameters, ex: /en/contact/)</option>
							<option value="13">True or False</option>
						</select>
					</div>
				</li>
				<!-- <li>
					<ul class="options">
						<li><label class="flex-label"><input type="checkbox" name="" value="formatting" checked="checked">Editable in overview</label>
							<div class="description">Use with caution, validation > to check!!</div>
						</li>
					</ul>
				</li> -->
				<li>
					<label>Class</label> <input type="text" name="property.settings.class.value" :value="classField">
				</li>
			</ul>
		</div>

		<template v-if="field.property.settings.type.value === 'Editor'">
			<a href="#" class="btn-group" data-tab-btn="options-editor" data-tab-group="options-bar"><i class="fa fa-plus"></i>
				Editor toolbar</a>
			<div class="group" data-tab-body="options-editor" data-tab-group="options-bar">

				<ul class="form">
					<li>
						<label>Allow in editor</label>
						<ul class="options colums2">
							<li>
								<label class="flex-label">
									<input type="checkbox" name="property.settings.editor.value" value="formatting" :checked="checkIfValueExistsInArray('formatting', editorSettings)">Headings
								</label>
							</li>
							<li>
								<label class="flex-label">
									<input type="checkbox" name="property.settings.editor.value" value="bold" :checked="checkIfValueExistsInArray('bold', editorSettings)">Bold
								</label>
							</li>
							<li>
								<label class="flex-label">
									<input type="checkbox" name="property.settings.editor.value" value="italic" :checked="checkIfValueExistsInArray('italic', editorSettings)">Italic
								</label>
							</li>
							<li>
								<label class="flex-label">
									<input type="checkbox" name="property.settings.editor.value" value="underline" :checked="checkIfValueExistsInArray('underline', editorSettings)">Underline
								</label>
							</li>
							<li>
								<label class="flex-label">
									<input type="checkbox" name="property.settings.editor.value" value="link" :checked="checkIfValueExistsInArray('link', editorSettings)">Links
								</label>
							</li>
							<li>
								<label class="flex-label">
									<input type="checkbox" name="property.settings.editor.value" value="lists" :checked="checkIfValueExistsInArray('lists', editorSettings)">Lists
								</label>
							</li>
							<li>
								<label class="flex-label">
									<input type="checkbox" name="property.settings.editor.value" value="image" :checked="checkIfValueExistsInArray('image', editorSettings)">Images
								</label>
							</li>
							<li>
								<label class="flex-label">
									<input type="checkbox" name="property.settings.editor.value" value="video" :checked="checkIfValueExistsInArray('video', editorSettings)">Video
								</label>
							</li>
							<li>
								<label class="flex-label">
									<input type="checkbox" name="property.settings.editor.value" value="html" :checked="checkIfValueExistsInArray('html', editorSettings)">HTML
								</label>
							</li>
						</ul>
					</li>
				</ul>
			</div>
		</template>

		<template v-if="['Select', 'Multiselect', 'Radio', 'Checkbox'].indexOf(field.property.settings.type.value) > -1">
			<OptionsConfigurator :endpoint="endpoint" :languages="languages" :options="options"></OptionsConfigurator>
		</template>

		<template v-if="['Dropzone', 'Fileupload'].indexOf(field.property.settings.type.value) > -1">
			<a href="#" class="btn-group" data-tab-btn="options-filetypes" data-tab-group="options-bar"><i class="fa fa-plus"></i>
				Allowed files</a>
			<div class="group" data-tab-body="options-filetypes" data-tab-group="options-bar">

				<ul class="form">
					<li>
						<label></label>
						<ul class="options colums3">
							<li>
								<label class="flex-label">
									<input type="checkbox" name="property.settings.filetype.value" value="application/pdf" :checked="checkIfValueExistsInArray('application/pdf', fileTypes)"> pdf
								</label>
							</li>
							<li>
								<label class="flex-label">
									<input type="checkbox" name="property.settings.filetype.value" value="application/txt" :checked="checkIfValueExistsInArray('application/txt', fileTypes)"> txt
								</label>
							</li>
							<li>
								<label class="flex-label">
									<input type="checkbox" name="property.settings.filetype.value" value="application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" :checked="checkIfValueExistsInArray('application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document', fileTypes)"> doc, docx
								</label>
							</li>
							<li>
								<label class="flex-label">
									<input type="checkbox" name="property.settings.filetype.value" value="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" :checked="checkIfValueExistsInArray('application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', fileTypes)"> xls, xlsx
								</label>
							</li>
							<li>
								<label class="flex-label">
									<input type="checkbox" name="property.settings.filetype.value" value="application/zip" :checked="checkIfValueExistsInArray('application/zip', fileTypes)"> zip
								</label>
							</li>
							<li>
								<label class="flex-label">
									<input type="checkbox" name="property.settings.filetype.value" value="image/jpeg" :checked="checkIfValueExistsInArray('image/jpeg', fileTypes)"> jpg
								</label>
							</li>
							<li>
								<label class="flex-label">
									<input type="checkbox" name="property.settings.filetype.value" value="image/png" :checked="checkIfValueExistsInArray('image/png', fileTypes)"> png
								</label>
							</li>
							<li>
								<label class="flex-label">
									<input type="checkbox" name="property.settings.filetype.value" value="image/gif" :checked="checkIfValueExistsInArray('image/gif', fileTypes)"> gif
								</label>
							</li>
						</ul>
					</li>
					<li>
						<label>Maximum allowed filesize (Mb)</label>
						<input type="text" name="property.settings.maxfilesize.value" :value="maxFileSize">
					</li>
					<li>
						<ul class="list split">
							<li>
								<label>
									Image width (px)
									<input type="number" name="property.settings.width.value" :value="imageWidth">
								</label>
							</li>
							<li>
								<label>
									Image height (px)
									<input type="number" name="property.settings.height.value" :value="imageHeight">
								</label>
							</li>
						</ul>
					</li>
				</ul>

			</div>
		</template>

		<template v-if="field.property.settings.type.value === 'Reference'">
			<a href="#" class="btn-group" data-tab-btn="options-reference" data-tab-group="options-bar"><i class="fa fa-plus"></i>
				Reference settings</a>
			<div class="group" data-tab-body="options-reference" data-tab-group="options-bar">

				<ul class="form">
					<li>
						<label>Object to reference to:</label>
						<div class="selector">
							<select name="property.settings.referenceId.value" @change="referenceChangeHandler">
								<option value="">None</option>
								<template v-for="entity in entities">
									<template v-if="entity.translations">
										<option :key="entity.id" :value="entity.id" :selected="referenceId == entity.id">{{entity.translations.en.value}}</option>
									</template>
								</template>
							</select>
						</div>
					</li>
					<li v-if="refElements">
						<label>Show this field in selection as value:</label>
						<div class="selector">
							<select name="property.settings.referenceFieldId.value">
								<option value="">None</option>
								<template v-for="refElement in refElements">
									<option :key="refElement.property.id" :value="refElement.property.id" :selected="referenceFieldId == refElement.property.id">{{ refElement.property.translations.en.value }}</option>
								</template>
							</select>
						</div>
					</li>
					<li>
						<label>Element type:</label>
						<ul class="options colums1">
							<li><label class="flex-label"><input type="radio" name="property.settings.reference.value" value="select" :checked="this.referenceFieldType === 'select'"> Select</label></li>
							<li><label class="flex-label"><input type="radio" name="property.settings.reference.value" value="radio" :checked="this.referenceFieldType === 'radio'"> Radio</label></li>
							<li><label class="flex-label"><input type="radio" name="property.settings.reference.value" value="checkbox" :checked="this.referenceFieldType === 'checkbox'"> Checkbox</label></li>
						</ul>
					</li>
				</ul>

			</div>
		</template>

		<template v-if="field.property.settings.type.value === 'Editable reference'">
			<a href="#" class="btn-group" data-tab-btn="options-editable-reference" data-tab-group="options-bar"><i class="fa fa-plus"></i>
				Editable references</a>
			<div class="group" data-tab-body="options-editable-reference" data-tab-group="options-bar">

				<ul class="form">
					<li>
						<label>Object to reference to:</label>
						<div class="selector">
							<select name="property.settings.referenceId.value">
								<option value="">None</option>
								<template v-for="entity in entities">
									<template v-if="entity.translations">
										<option :key="entity.id" :value="entity.id" :selected="referenceId == entity.id">{{entity.translations.en.value}}</option>
									</template>
								</template>
							</select>
						</div>
					</li>
					<!-- <li>
						<label>Select editable fields, mandatory fields can not be disabled:</label>
						<ul class="options colums1">
							<li><label class="flex-label"><input type="checkbox" name="" value="" disabled checked> Lorum ipsum</label></li>
							<li><label class="flex-label"><input type="checkbox" name="" value=""> Consectetur adipiscing elit.</label></li>
							<li><label class="flex-label"><input type="checkbox" name="" value=""> Integer mollis interdum</label></li>
						</ul>
					</li> -->
					<!-- <li>
						<label> <input type="checkbox" class="toggle"> Sortable</label>
					</li> -->
				</ul>

			</div>
		</template>

		<template v-if="!['Editable reference', 'Dropzone', 'Fileupload', 'Link', 'Tag'].includes(field.property.settings.type.value)">
			<a href="#" class="btn-group" data-tab-btn="options-default-value" data-tab-group="options-bar"><i class="fa fa-plus"></i>
				Default value(s)</a>
			<div class="group" data-tab-body="options-default-value" data-tab-group="options-bar">

				<ul class="form">
					<li v-if="field.property.settings.type.value === 'Textfield'">
						<input type="text" name="property.settings.defaultValue.value" :value="defaultValue">
					</li>
					<li v-if="field.property.settings.type.value === 'Radio'">
						<ul class="options colums1">
							<li v-for="option in field.options" :key="option.id">
								<label class="flex-label"><input type="radio" name="property.settings.defaultValue.value" :checked="defaultValue == option.value" :value="option.value">{{ option.value }}</label>
							</li>
						</ul>
					</li>
				</ul>

			</div>
		</template>

		<template v-if="field.property.settings.type.value === 'Tag'">
			<a href="#" class="btn-group" data-tab-btn="options-showpad" data-tab-group="options-bar"><i class="fa fa-plus"></i>Showpad settings</a>
			<div class="group" data-tab-body="options-showpad" data-tab-group="options-bar">
				<ul class="form">
					<li>
						<ul class="options colums1">
							<li><label class="flex-label"><input type="checkbox" name="" value=""> Allow adding tags by user</label></li>
						</ul>
					</li>
				</ul>
			</div>
		</template>

		<template v-if="field.property.settings.type.value === 'Link'">
			<a href="#" class="btn-group" data-tab-btn="link-settings" data-tab-group="options-bar"><i class="fa fa-plus"></i>
				Link settings</a>
			<div class="group" data-tab-body="link-settings" data-tab-group="options-bar">

				<ul class="form">
					<li>
						<label>Select available input types:</label>
						<ul class="options colums1">
							<li><label class="flex-label"><input type="checkbox" name="property.settings.linksettings.value" value="Internal" :checked="checkIfValueExistsInArray('Internal', linkSettings)"> Internal</label></li>
							<li><label class="flex-label"><input type="checkbox" name="property.settings.linksettings.value" value="External" :checked="checkIfValueExistsInArray('External', linkSettings)"> External</label></li>
							<li><label class="flex-label"><input type="checkbox" name="property.settings.linksettings.value" value="Asset" :checked="checkIfValueExistsInArray('Asset', linkSettings)"> Asset</label></li>
							<li><label class="flex-label"><input type="checkbox" name="property.settings.linksettings.value" value="Page" :checked="checkIfValueExistsInArray('Page', linkSettings)"> Page</label></li>
						</ul>
					</li>
				</ul>

			</div>
		</template>

		<template v-if="conditionalParent && conditionalOptions">
			<a href="#" class="btn-group" data-tab-btn="options-conditional" data-tab-group="options-bar"><i class="fa fa-plus"></i>
				Conditional rules</a>
			<div class="group" data-tab-body="options-conditional" data-tab-group="options-bar">

				<ul class="form">
					<li v-if="conditionalParent">
						<label><strong>By default this field is hidden.</strong><br> Show this field when parent value is equal to:</label>
						<ul class="options colums1" v-if="conditionalOptions">
							<li v-for="option in conditionalOptions" :key="option.id">
								<label v-if="option.value" class="flex-label">
									<input type="checkbox" name="property.settings.conditional.value" :value="option.value" :checked="checkIfValueExistsInArray(option.value, chosenConditionalIDs)"> {{option.translations.en.value}}
								</label>
								<label class="flex-label" v-else>
									<input type="checkbox" name="property.settings.conditional.value" :value="option.uuid" :checked="checkIfValueExistsInArray(option.uuid, chosenConditionalIDs)"> {{option.name}}
								</label>
							</li>
						</ul>
					</li>
				</ul>

			</div>
		</template>

	</form>
</template>

<script>

import OptionsConfigurator from './objectEditComponents/OptionsConfigurator.vue'
import _ from 'lodash/object'
import xhrModule from '../../modules/xhrModule.js'
import general from '../../modules/general.js'

export default {
	name: 'object-edit-sidebar',
	props: {
		data: Object
	},

	components: {
		'OptionsConfigurator': OptionsConfigurator
	},

	data () {
		return {
			field: null,
			fields: null,
			languages: null,
			options: {},
			entities: null,
			conditionalParent: null,
			conditionalOptions: null,
			chosenConditionalIDs: null,
			refElements: null
		}
	},

	created () {
		this.body = document.querySelector('body')

		var url = '/cms/api/markets'
		xhrModule.get(url, this.getMarketsCompleteHandler.bind(this))
	},

	updated () {
	},

	mounted () {
		// set form
		this.form = this.data.form

		// set fields
		this.fields = this.data.fields

		// values
		this.field = this.data.field

		this.conditionalParent = null
		if (this.data.field.property.settings.conditionalParent && this.data.field.property.settings.conditionalParent.state !== 5) this.conditionalParent = this.data.field.property.settings.conditionalParent.value

		this.chosenConditionalIDs = null
		if (this.data.field.property.settings.conditional && this.data.field.property.settings.conditional.state !== 5) this.chosenConditionalIDs = JSON.parse(this.data.field.property.settings.conditional.value)

		// link settings
		this.linkSettings = '["Internal","External","Asset","Page"]'
		if (this.data.field.property.settings.linksettings) this.linkSettings = this.data.field.property.settings.linksettings.value

		// editor settings
		this.editorSettings = '["formatting","bold","italic","underline","link","lists","image","video","html"]'
		if (this.data.field.property.settings.editor) this.editorSettings = this.data.field.property.settings.editor.value

		// file settings
		this.fileTypes = null
		if (this.data.field.property.settings.filetype) this.fileTypes = this.data.field.property.settings.filetype.value

		this.maxFileSize = 5
		if (this.data.field.property.settings.maxfilesize) this.maxFileSize = this.data.field.property.settings.maxfilesize.value

		this.imageWidth = 0
		if (this.data.field.property.settings.width) this.imageWidth = this.data.field.property.settings.width.value

		this.imageHeight = 0
		if (this.data.field.property.settings.height) this.imageHeight = this.data.field.property.settings.height.value

		// define values for fields
		this.descriptionField = null
		if (this.data.field.property.settings.description) this.descriptionField = this.data.field.property.settings.description.value

		this.validationField = '2'
		if (this.data.field.property.settings.validation) this.validationField = this.data.field.property.settings.validation.value

		this.options = {}
		if (this.data.field.options) {
			// add all langs for each options when there is no data
			for (var key in this.data.field.options) {
				var translations = this.data.field.options[key].translations
				if (translations) {
					for (var lang in this.languages) {
						if (!translations[this.languages[lang].locale]) {
							translations[this.languages[lang].locale] = {
								'id': 0,
								'value': '',
								'market': this.languages[lang].id
							}
						}
					}
				}
			}

			if (this.data.field.options) this.options = this.data.field.options
		}

		// reference field
		this.referenceFieldType = null
		if (this.data.field.property.settings.reference) this.referenceFieldType = this.data.field.property.settings.reference.value

		this.referenceId = null
		if (this.data.field.property.settings.referenceId) this.referenceId = this.data.field.property.settings.referenceId.value
		if (this.referenceId) {
			this.fetchReferenceFields(this.referenceId)
		}

		this.referenceFieldId = null
		if (this.data.field.property.settings.referenceFieldId) this.referenceFieldId = this.data.field.property.settings.referenceFieldId.value

		this.defaultValue = null
		if (this.data.field.property.settings.defaultValue) this.defaultValue = this.data.field.property.settings.defaultValue.value

		this.endpoint = null
		if (this.data.field.property.settings.endpoint) this.endpoint = this.data.field.property.settings.endpoint.value

		this.classField = null
		if (this.data.field.property.settings.class) this.classField = this.data.field.property.settings.class.value

		if (this.data.field.property.settings.type.value === 'Reference' || this.data.field.property.settings.type.value === 'Editable reference') {
			var url = '/cms/api/entities'
			xhrModule.get(url, this.getEntitiesCompleteHandler.bind(this))
		}

		this.getOptionsForConditionalParent()
	},

	methods: {
		referenceChangeHandler (e) {
			var target = e.currentTarget
			var referencedEntityID = target.value
			this.fetchReferenceFields(referencedEntityID)
		},

		fetchReferenceFields (id) {
			var url = '/cms/api/forms?entity=' + id
			xhrModule.get(url, this.getReferenceFormFieldsCompleteHandler.bind(this))
		},

		getReferenceFormFieldsCompleteHandler (data) {
			this.refElements = data.data[Object.keys(data.data)[0]].elements
		},

		getOptionsForConditionalParent () {
			// go trough the form element and pick out the options for the element property with the ID that matches with our conditionalParent ID
			if (!this.form) return
			var elements = this.form.elements
			for (var el in elements) {
				if (elements[el].property.id == this.conditionalParent) {
					if (elements[el].options) {
						// non reference
						this.conditionalOptions = Object.values(elements[el].options)
						this.conditionalOptions.sort(function (a, b) {
							return a.priority - b.priority
						})
					} else {
						// reference
						const referenceEntityID = elements[el].property.settings.referenceId.value
						this.conditionalParentReferenceFieldId = elements[el].property.settings.referenceFieldId.value
						const url = '/cms/api/instances/ofEntity?entity=' + referenceEntityID
						xhrModule.get(url, this.referenceCallbackCompleted.bind(this))
					}
				}
			}
		},

		referenceCallbackCompleted (data) {
			const referenceFieldName = data.linked.entity.properties[this.conditionalParentReferenceFieldId].name
			data.data.sort(function (a, b) {
				return a.properties[referenceFieldName] - b.properties[referenceFieldName]
			})

			if (!this.languages) return

			// remove id 1 from object (cms language)
			let langs = JSON.parse(JSON.stringify(this.languages))
			for (let lang in langs) {
				if (langs[lang].id === 1) delete langs[lang]
			}

			// find default lang
			const defaultLang = general.findItemWithLowestPriority(langs)

			// filter out extra languages
			let finalArrayRefs = []
			for (var i = 0; i < data.data.length; i++) {
				if (data.data[i].market == defaultLang.id) {
					finalArrayRefs.push({
						uuid: data.data[i].uuid,
						name: data.data[i].properties[referenceFieldName]
					})
				}

				if (i === data.data.length - 1) {
					this.conditionalOptions = finalArrayRefs
				}
			}
		},

		getMarketsCompleteHandler (markets) {
			this.languages = markets.data

			this.getOptionsForConditionalParent()
		},

		getEntitiesCompleteHandler (data) {
			this.entities = data.data
		},

		save () {
			// gather all data
			var formData = new FormData(this.$el)

			var object = {}
			formData.forEach((value, key) => {
				if (!Reflect.has(object, key)) {
					object[key] = value
					return
				}
				if (!Array.isArray(object[key])) {
					object[key] = [object[key]]
				}
				object[key].push(value)
			})

			var merged = {}
			for (var key in object) {
				_.set(merged, key, object[key])
			}

			// merge settings
			if (merged.property.settings) {
				for (var key1 in merged.property.settings) {
					// check if this ID already exists or not
					var id = 0
					if (this.data.field.property.settings[key1]) {
						id = this.data.field.property.settings[key1].id
					}
					merged.property.settings[key1].id = id
					merged.property.settings[key1].name = key1
					merged.property.settings[key1].state = 3

					if (['editor', 'linksettings', 'filetype'].indexOf(key1) > -1) {
						var val2 = null
						if (Array.isArray(merged.property.settings[key1].value)) {
							val2 = JSON.stringify(merged.property.settings[key1].value)
						} else {
							val2 = '["' + merged.property.settings[key1].value + '"]'
						}
						merged.property.settings[key1].value = val2
					}

					// when there are conditional options (select, checkboxes, radio)
					if (key1 === 'conditional') {
						var val1 = null
						if (Array.isArray(merged.property.settings[key1].value)) {
							val1 = JSON.stringify(merged.property.settings[key1].value)
						} else {
							val1 = '["' + merged.property.settings[key1].value + '"]'
						}
						merged.property.settings[key1].value = val1
					}

					this.data.field.property.settings[key1] = merged.property.settings[key1]
				}
			}

			// merge options
			if (merged.options) {
				for (var key2 in merged.options) {
					if (!this.data.field.options) this.data.field.options = {}

					if (merged.options[key2].id.indexOf('tempoption-') > -1) {
						merged.options[key2].id = 0
					}

					merged.options[key2].state = parseInt(merged.options[key2].state)
					merged.options[key2].priority = parseInt(merged.options[key2].priority)

					// link ID's and markets for translations
					var optionTranslations = merged.options[key2].translations
					for (var lang1 in optionTranslations) {
						// must be 0 when this is a new translation
						if (this.data.field.options[key2]) {
							optionTranslations[lang1].id = this.data.field.options[key2].translations[lang1].id
						} else {
							optionTranslations[lang1].id = 0
						}

						for (var market1 in this.languages) {
							if (this.languages[market1].locale === lang1) {
								optionTranslations[lang1]['market'] = this.languages[market1].id
							}
						}
					}
				}

				var finalOptions = []
				for (var n in merged.options) {
					finalOptions.push(merged.options[n])
				}

				this.data.field.options = finalOptions
			}

			this.data.saveCallbackFunction(this.data.field, this.data.fields)

			// close sidebar
			this.$parent.toggle()
		}
	}
}

</script>
